import useCoverPreview from "../hooks/useCoverPreview"
import useAwardForm from "../hooks/useAwardForm"

const PLACE_OPTIONS = [
  { value: "", label: "—" },
  { value: "1", label: "1 місце" },
  { value: "2", label: "2 місце" },
  { value: "3", label: "3 місце" },
]

// A row of selectable chips backing a single value (kind / place / direction).
const ChipRow = ({ label, options, value, onChange, delay }) => (
  <div className="cf-genres" style={{ animationDelay: `${delay}ms` }}>
    <span className="cf-genres__label">{label}</span>
    <div className="cf-genres__chips" role="radiogroup" aria-label={label}>
      {options.map((opt) => {
        const selected = opt.value === value
        return (
          <button
            type="button"
            key={opt.value || "none"}
            role="radio"
            aria-checked={selected}
            className={`cf-chip${selected ? " is-selected" : ""}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.icon && <i className={`fa-solid ${opt.icon}`} aria-hidden="true"></i>}
            {opt.icon ? " " : ""}{opt.label}
          </button>
        )
      })}
    </div>
  </div>
)

// The whole create/edit form — no typing, just a photo plus three chip choices.
// Submits over fetch as multipart FormData so we can stay on the page and play
// submit → success animations instead of a full reload.
const AwardForm = ({ config }) => {
  const { preview, coverName, fileRef, onFile } = useCoverPreview(config.photo_url)
  const { values, status, formError, shake, change, submit } =
    useAwardForm(config, () => fileRef.current?.files[0])

  const kindOptions = config.kinds.map((k) => ({ value: k.code, label: k.label, icon: k.icon }))
  const directionOptions = config.directions.map((d) => ({ value: d.code, label: d.label, icon: d.icon }))
  const orientationOptions = config.orientations.map((o) => ({ value: o.code, label: o.label, icon: o.icon }))

  return (
    <form
      className={`cozy-form${shake ? " is-shaking" : ""}${status === "success" ? " is-done" : ""}`}
      onSubmit={submit}
      noValidate
    >
      {formError && <div className="cf-form-error">{formError}</div>}

      <div className="cf-cover" style={{ animationDelay: "60ms" }}>
        <span className="cf-cover__label">Фото / скан</span>
        <label className="cf-cover__drop" htmlFor="award_photo">
          {preview ? (
            <img key={preview} className="cf-cover__preview" src={preview} alt="" />
          ) : (
            <span className="cf-cover__icon" aria-hidden="true">＋</span>
          )}
          <span className="cf-cover__hint">
            {coverName ? coverName : preview ? "Натисни, щоб замінити" : "Обери зображення"}
          </span>
        </label>
        <input
          ref={fileRef}
          id="award_photo"
          type="file"
          accept="image/*"
          onChange={onFile}
          hidden
        />
      </div>

      <ChipRow label="Тип нагороди" options={kindOptions} value={values.kind} onChange={(v) => change("kind", v)} delay={120} />
      <ChipRow label="Орієнтація рамки" options={orientationOptions} value={values.orientation} onChange={(v) => change("orientation", v)} delay={180} />
      <ChipRow label="Напрямок" options={directionOptions} value={values.direction} onChange={(v) => change("direction", v)} delay={240} />
      <ChipRow label="Місце (необовʼязково)" options={PLACE_OPTIONS} value={values.place} onChange={(v) => change("place", v)} delay={300} />

      <div className="cf-actions" style={{ animationDelay: "360ms" }}>
        <button type="submit" className={`btn btn-primary cf-submit cf-submit--${status}`} disabled={status !== "idle"}>
          <span className="cf-submit__label">
            {config.persisted ? "Зберегти зміни" : "Додати до колекції"}
          </span>
          <span className="cf-submit__spinner" aria-hidden="true" />
          <span className="cf-submit__check" aria-hidden="true">✓</span>
        </button>
        <a className="btn btn-ghost" href="/awards">Скасувати</a>
      </div>
    </form>
  )
}

export default AwardForm
